var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.206,24.607H3.4a1.4,1.4,0,0,1-1.4-1.4V13.4A1.4,1.4,0,0,1,3.4,12h9.805a1.4,1.4,0,0,1,1.4,1.4v9.805A1.4,1.4,0,0,1,13.206,24.607ZM3.4,13.4v9.805h9.805V13.4Z",
    transform: "translate(-0.599 -3.595)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.206,18.206h-1.4V8.4H9V7h9.805a1.4,1.4,0,0,1,1.4,1.4Z",
    transform: "translate(-2.697 -2.097)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.805,11.805H24.4V3.4H16V2h8.4a1.4,1.4,0,0,1,1.4,1.4Z",
    transform: "translate(-4.794 -0.599)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackH);
export default __webpack_public_path__ + "static/media/stack-h.64013027d04d0f3a43c3e18cf32aba96.svg";
export { ForwardRef as ReactComponent };